import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import { ArrowLeft, ArrowRight, Building2, MapPin } from "lucide-react";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import HomeService from "../../../Services/HomeService";

import heroImg from "../../../Images/hero-villa.jpg";
import cityImg from "../../../Images/city-skyline.jpg";
import interiorImg from "../../../Images/apartment-interior.jpg";
import towerImg from "../../../Images/property-tower.jpg";
import { useNavigate } from "react-router-dom";

export function WinnersTopProjectsBlue() {
  const sliderRef = useRef(null);
  const navigate = useNavigate();
  const [highlightedProjects, setHighlightedProjects] = useState([]);

  const projects = [
    {
      title: "The Sand Residences",
      desc: "92 curated suites with private terraces",
      price: "₹2.4 Cr",
      type: "Luxury Apartment",
      loc: "Gurgaon Sector 65",
      img: towerImg,
    },
    {
      title: "Aurum Vistas",
      desc: "Sky-villas with panoramic city views",
      price: "₹4.8 Cr",
      type: "Penthouse",
      loc: "Lucknow Hazratganj",
      img: heroImg,
    },
    {
      title: "Linea Quartier",
      desc: "Mid-rise community with green commons",
      price: "₹1.6 Cr",
      type: "Residence",
      loc: "Noida Extension",
      img: interiorImg,
    },
    {
      title: "Maison Dwarka",
      desc: "Boutique low-rise homes near the metro",
      price: "₹3.1 Cr",
      type: "Boutique Villa",
      loc: "Dwarka Sector 22",
      img: cityImg,
    },
  ];

  const fetchHighlightedProject = async () => {
    try {
      const res = await HomeService?.getHighlightedProject();
      console.log("highlighted projects blue", res);
      if (res?.status) {
        setHighlightedProjects(res?.data || []);
      } else {
        console.log(res);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchHighlightedProject();
  }, []);

  const displayProjects =
    highlightedProjects.length > 0
      ? highlightedProjects.map((p, index) => {
          const fallback = projects[index % projects.length];
          return {
            title: p?.title || "",
            desc: p?.shortDescription || "",
            price: p?.price || "",
            type: p?.type || "",
            locationText: p?.locationText || "",
            img: p?.image || fallback?.img,
            locationUrl: p?.locationUrl || "",
            propertyUrl: p?.propertyUrl || "",
          };
        })
      : projects;

  const settings = {
    dots: false,
    infinite: true,
    speed: 700,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const scroll = (dir) => {
    if (!sliderRef.current) return;

    if (dir === 1) {
      sliderRef.current.slickNext();
    } else {
      sliderRef.current.slickPrev();
    }
  };

  return (
    <section className="ws-top_blue">
      <div className="ws-top-inner_blue">
        <div className="ws-top-head_blue">
          <div>
            <span className="ws-section-eyebrow_blue">
              Highlighted projects
            </span>

            <h2 className="ws-section-heading_blue">
              Premium investments crafted for future living.
            </h2>
          </div>

          <div>
            <p>
              Handpicked real estate projects with modern architecture, premium
              amenities and prime city locations — ready for you to discover,
              visit and own.
            </p>

            <div className="ws-top-nav_blue">
              <button
                className="ws-nav-btn_blue"
                onClick={() => scroll(-1)}
                aria-label="Previous"
              >
                <ArrowLeft size={18} />
              </button>

              <button
                className="ws-nav-btn_blue"
                onClick={() => scroll(1)}
                aria-label="Next"
              >
                <ArrowRight size={18} />
              </button>
            </div>
          </div>
        </div>

        <Slider ref={sliderRef} {...settings} className="ws-top-track_blue">
          {displayProjects?.map((p) => (
            <div key={p.title}>
              <article className="ws-top-card_blue">
                <div className="ws-top-img_blue">
                  <img
                    src={p?.img}
                    alt={p?.title}
                    loading="lazy"
                    width={800}
                    height={500}
                  />

                  <span className="ws-top-tag_blue">Featured</span>
                </div>

                <div className="ws-top-body_blue">
                  <div className="ws-top-row_blue">
                    <div>
                      <h3>{p?.title}</h3>
                      <p>{p?.desc}</p>
                    </div>

                    <div className="ws-top-price_blue">
                      <span>Starting</span>
                      <strong>{p?.price}</strong>
                    </div>
                  </div>

                  <div className="ws-top-meta_blue">
                    <div className="ws-top-meta-item_blue">
                      <Building2 size={18} />

                      <div>
                        <span>Type</span>
                        <p>{p?.type}</p>
                      </div>
                    </div>

                    <div className="ws-top-meta-item_blue">
                      <MapPin size={18} />

                      <div
                        onClick={() =>
                          window.open(
                            p?.locationUrl,
                            "_blank",
                            "noopener,noreferrer",
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <span>Location</span>
                        <p>{p?.locationText}</p>
                      </div>
                    </div>
                  </div>

                  <div className="ws-top-footer_blue">
                    <button
                      onClick={() => {
                        navigate("/propertylist");
                      }}
                    >
                      Explore project
                    </button>
                    <button
                      onClick={() =>
                        window.open(
                          p?.propertyUrl,
                          "_blank",
                          "noopener,noreferrer",
                        )
                      }
                    >
                      View details
                    </button>
                  </div>
                </div>
              </article>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}

export default WinnersTopProjectsBlue;
